import { inject } from '@angular/core';
import { type CanMatchFn } from '@angular/router';

import { AuthService } from './auth.service';

/**
Blocks a route match entirely until the user is authenticated.

`CanMatch` (not `CanActivate`) runs before route matching completes, so an
unauthenticated user's attempt to reach a protected route never matches —
nothing under it renders. The user is sent to Keycloak's hosted login page;
returning `false` here prevents any flash of protected content while that
redirect takes effect.
@returns `true` if already authenticated; otherwise `false`, after starting a redirect to login.
*/
export const authGuard: CanMatchFn = () => {
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  void authService.login();

  return false;
};
